module.exports = __webpack_public_path__ + "img/MINUS.2bcf40ed.svg";